import { render, staticRenderFns } from "./taskManage.vue?vue&type=template&id=5fc1f5b4&scoped=true&"
import script from "./taskManage.vue?vue&type=script&lang=js&"
export * from "./taskManage.vue?vue&type=script&lang=js&"
import style0 from "./taskManage.vue?vue&type=style&index=0&id=5fc1f5b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1f5b4",
  null
  
)

export default component.exports